import { render, staticRenderFns } from "./ProgressCard.vue?vue&type=template&id=1b3ba2ae&"
import script from "./ProgressCard.vue?vue&type=script&lang=js&"
export * from "./ProgressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports